import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Tag } from '@app/core/models/Track';
import { GenericResolverResolver } from '@app/core/resolvers/generic-resolver.resolver';
import { RadioTagsState } from '@app/library/states/radio-tags.state';
import { Store } from '@ngxs/store';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class TagsFindResolver extends GenericResolverResolver<Tag> {
  constructor(router: Router, store: Store) {
    super(
      router,
      store,
      'tagid',
      combineLatest([
        store.select(RadioTagsState.tagsLoaded),
        store.select(RadioTagsState.isLoadingTags).pipe(map(val => !val)),
      ]).pipe(map(arr => arr.reduce((prev, curr) => prev && curr, true))),
      RadioTagsState.tags,
    );
  }

  getUrl(currentRadioId: number): any[] {
    return ['radio', currentRadioId, 'media', 'bac', 1];
  }
}
